<script setup lang="ts">
import { computed } from 'vue'

import { t } from '@satch-ui/translations/translations'
import { localizeUrl } from '@shared/fondof-fn/url/localize'
import { useCustomerStore } from '@shared/global-store/stores/customer/customer'
import { useWishlistStore } from '@shared/global-store/stores/wishlist/wishlist'

import { HeartStrokeGrayIcon } from '@fond-of/satch-icons'
import type { Customer } from '@fond-of/shop-api'

const props = defineProps<{
  customer?: Customer
  authorizationRedirectUri: string
}>()

const customerStore = useCustomerStore()
const wishlistStore = useWishlistStore()

const isAuthenticated = computed(() => {
  return !!props.customer || customerStore.isAuthenticated
})

const wishlistHref = computed(() =>
  isAuthenticated.value
    ? localizeUrl('/account/wishlist')
    : props.authorizationRedirectUri
)
</script>

<template>
  <a
    :href="wishlistHref"
    class="group/wishlist lg:bg mr-4 hidden w-fit cursor-pointer items-center transition-all lg:mr-0 lg:flex lg:rounded-[500px] lg:py-2"
  >
    <HeartStrokeGrayIcon
      class="mr-1 w-4"
      :class="
        wishlistStore.itemCount > 0 ? 'text-gray-icon' : 'text-transparent'
      "
    />

    <span
      class="line text-nav text-gray-topnav min-h-fit min-w-fit flex-auto whitespace-nowrap leading-[normal]"
    >
      {{ t('wishlist.myWishlist') }}
    </span>
    <span
      v-if="wishlistStore.itemCount > 0"
      class="text-nav text-gray-topnav ml-1 leading-[normal]"
    >
      ({{ wishlistStore.itemCount }})
    </span>
  </a>
</template>
